(function() {
    'use strict';
    angular.module('wbUtilities').directive('radialProgress', ['$window', '$timeout', function($window, $timeout) {
    return {
        restrict: 'A',
        scope: {
            config: '=',
            percent: '=',
        },
        templateUrl: "/common/src/app/directives/radial-progress/radial-progress.tpl.html",
        link: function(scope, $el, attrs) {

            var progress = new PB(scope.config, scope.percent);

            progress.render($el[0]);

            scope.$watch('percent', function(percent) {
                return progress.update(percent);
            });

            function PB(config, percent) {
                this.τ = 2 * Math.PI;
                this.radian = Math.PI/180;
                this.percent = parseFloat(percent);

                this.c = {
                    duration: 200,
                    width: 200,
                    height: 200,
                    arcThickness: 0.2,
                    capRadius: 1,
                    min: 0,
                    max: 100,
                    startAngle: -180 + 20,
                    endAngle: 180 - 20,
                };
                angular.extend(this.c, config);

                this.c.radius = (this.c.width / 2);

                this.s = {};
                this.m = {};

                this.getEndRadian = function(percent) {
                    var theta = (this.c.startAngle === this.c.endAngle)
                        ? 360 : (this.c.startAngle > this.c.endAngle)
                            ? 360-(this.c.startAngle - this.c.endAngle) : this.c.endAngle - this.c.startAngle;

                    var spread = percent/(this.c.max-this.c.min);
                    spread = [0, spread || 0, 1].sort()[1];

                    return (spread * theta) * this.radian + this.m.arcStartRadian;
                };

                this.measure = function() {

                    // Calculate arc thickness for radius
                    var arcThickness = this.c.radius * this.c.arcThickness;

                    // Calculate start angle in radians
                    this.m.arcStartRadian = this.c.startAngle * this.radian;

                    this.m.arcEndRadian = this.getEndRadian(this.percent);

                    // Create arc object
                    this.m.arc = d3.svg.arc();
                    this.m.arc.outerRadius(this.c.radius)
                        .innerRadius(this.c.radius-arcThickness)
                        .cornerRadius(arcThickness*this.c.capRadius/2);
                    this.m.arcData = {
                        arc: this.m.arc,
                        startAngle: this.m.arcStartRadian,
                        endAngle: this.m.arcStartRadian
                    };

                    // Create arcTrack object
                    this.m.arcTrack = d3.svg.arc();
                    this.m.arcTrack.outerRadius(this.c.radius)
                        .innerRadius(this.c.radius-arcThickness)
                        .cornerRadius(arcThickness*this.c.capRadius/2)
                        .startAngle(this.m.arcStartRadian)
                        .endAngle(this.getEndRadian(100));

                };

                this.render = function(element) {
                    this.measure();

                    this.s.root = d3.select(element);
                    this.s.svg = this.s.root.select(".radial-progress-div")
                        .append("svg")
                        .attr("style", "overflow: visible;")
                        .attr("class", "svg-content")
                        .attr('viewBox', '0 0 ' + this.c.height + ' ' + this.c.width)
                        .attr('preserveAspectRatio', 'xMinYMin meet');

                    this.s.plot = this.s.svg.append("g")
                        .attr("class","progress-plot");
                    this.s.plotBackground = this.s.plot.append("rect").attr("class","plot-background");

                    this.s.arcPlot = this.s.plot.append("g")
                        .attr("class","progress-arc-plot")
                        .attr("transform","translate(" + this.c.width/2 + "," + this.c.height/2 + ")");
                    this.s.backCircle = this.s.arcPlot.append("circle")
                        .attr("class","progress-back-circle")
                        .attr("r",this.radius);

                    this.s.trackPath = this.s.arcPlot.append("path")
                        .attr("class","progress-track")
                        .attr("d",this.m.arcTrack);

                    this.s.arcPath = this.s.arcPlot.append("path")
                        .attr("class","progress-arc")
                        .datum(this.m.arcData)
                        .attr("d",this.m.arc);

                    this.s.labelPlot = this.s.plot.append("g")
                        .attr("class","progress-label-plot")
                        .attr("transform", "translate(" + this.c.width / 2 + "," + this.c.height / 2 + ")");
                    this.s.label = this.s.labelPlot.append("text").text("%")
                        .attr("class","progress-label")
                        .attr("transform", "translate(0, 15)")
                        .style('font-size', "3.1em")
                        .style("text-anchor", "middle");


                };

                this.update = function(percent) {
                    if (typeof percent !== "undefined") {
                        this.percent = parseFloat(percent);
                        this.s.arcPath.transition()
                            .duration(this.c.duration)
                            .call(arcTween, this.getEndRadian(this.percent));

                        this.s.label.text(this.percent.toFixed(0)+"%").style('font-size', this.getFontSize(this.percent));

                    }
                };
                this.getFontSize = function(percent) {
                    var text = percent.toFixed(0);
                    if (text.length > 2) {
                        return "2.9em";
                    } else {
                        return "3.1em";
                    }
                };

                function arcTween(transition, newAngle) {
                    return transition.attrTween("d", function(d) {
                        var interpolate = d3.interpolate(d.endAngle, newAngle);
                        return function(t) {
                            d.endAngle = interpolate(t);
                            return d.arc(d);
                        };
                    });
                }
            }
        }};
    }]);

})();


